import React, { useEffect, useState } from "react";
import { Instagram, Facebook, Phone, Mail } from "lucide-react";
import { CONTACT } from "../../lib/constants";

export const TopBar = () => {
  const [hidden, setHidden] = useState(false);

  useEffect(() => {
    const onScroll = () => setHidden(window.scrollY > 40);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <div
      data-testid="top-bar"
      style={{ touchAction: "manipulation" }}
      className={`fixed top-0 left-0 right-0 z-[60] bg-accent-dark text-white/90 transition-transform duration-500 ${
        hidden ? "-translate-y-full" : "translate-y-0"
      }`}
    >
      <div className="max-w-7xl mx-auto px-3 sm:px-6 md:px-10 min-h-[44px] md:min-h-[40px] flex items-center justify-between gap-2 text-[11px] md:text-xs">
        {/* Left: phone + email — larger tap targets on mobile */}
        <div className="flex items-center gap-1 sm:gap-3 md:gap-6 min-w-0">
          <a
            href={CONTACT.telLink}
            data-testid="topbar-phone"
            aria-label={`Call ${CONTACT.whatsappNumber}`}
            className="flex items-center gap-1.5 px-2 py-2.5 -mx-2 hover:text-gold active:text-gold transition-colors whitespace-nowrap"
          >
            <Phone size={13} className="shrink-0" />
            <span className="hidden sm:inline">{CONTACT.whatsappNumber}</span>
            <span className="sm:hidden font-medium">Call</span>
          </a>
          <a
            href={CONTACT.mailLink}
            data-testid="topbar-email"
            aria-label={`Email ${CONTACT.email}`}
            className="flex items-center gap-1.5 px-2 py-2.5 -mx-2 hover:text-gold active:text-gold transition-colors truncate"
          >
            <Mail size={13} className="shrink-0" />
            <span className="hidden sm:inline truncate">{CONTACT.email}</span>
            <span className="sm:hidden font-medium">Email</span>
          </a>
        </div>

        {/* Right: socials */}
        <div className="flex items-center gap-1 sm:gap-3 md:gap-5 shrink-0">
          <a
            href={CONTACT.instagram}
            target="_blank"
            rel="noreferrer"
            aria-label="Instagram"
            data-testid="topbar-instagram"
            className="p-2 hover:text-gold active:text-gold transition-colors"
          >
            <Instagram size={14} />
          </a>
          <a
            href={CONTACT.facebook}
            target="_blank"
            rel="noreferrer"
            aria-label="Facebook"
            data-testid="topbar-facebook"
            className="p-2 hover:text-gold active:text-gold transition-colors"
          >
            <Facebook size={14} />
          </a>
        </div>
      </div>
    </div>
  );
};
